import { CommonModule } from '@angular/common';
import { Component, Input, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NgScrollbarModule } from 'ngx-scrollbar';

const menuList: {
  name: string;
  link: string[] | string;
  type: string;
  exact: boolean;
  icon: string;
  subMenuList?: {
    name: string;
    link: string[] | string;
    type: string;
    exact: boolean;
    icon: string;
  }[];
}[] = [
  {
    name: 'Dashboard',
    link: ['/', 'gov-dashboard'],
    type: 'All',
    exact: true,
    icon: 'assets/svgs/menu/dashboard.svg',
  },
  {
    name: 'MDA Analytics',
    link: ['/', 'gov-dashboard', 'mda-analytics'],
    type: 'All',
    exact: false,
    icon: 'assets/svgs/menu/analytic.svg',
  },
  // {
  //   name: 'Collections Summary',
  //   link: ['/', 'gov-dashboard', 'collections-summary'],
  //   type: 'All',
  //   exact: false,
  //   icon: 'assets/svgs/menu/fiscal-analytics.svg',
  // },
  {
    name: 'Collection Analytics',
    link: ['/', 'gov-dashboard', 'collection-analytics'],
    type: 'All',
    exact: false,
    icon: 'assets/svgs/menu/collection.svg',
  },
  {
    name: 'Fiscal Health Analytics',
    link: ['/', 'gov-dashboard', 'fiscal-health-analytics'],
    type: 'All',
    exact: false,
    icon: 'assets/svgs/menu/fiscal-analytics.svg',
  },
  {
    name: 'Log Out',
    link: '/',
    type: 'Danger',
    exact: true,
    icon: 'assets/svgs/menu/log-out.svg',
  },
];

@Component({
  selector: 'app-governor-sidemenu',
  standalone: true,
  imports: [
    SvgIconComponent,
    NzToolTipModule,
    RouterModule,
    NgScrollbarModule,
    CommonModule,
    NzMenuModule,
  ],
  templateUrl: './governor-sidemenu.component.html',
  styleUrl: './governor-sidemenu.component.css',
})
export class GovernorSidemenuComponent {
  @Input({ required: true }) isCollapsed = false;

  menuList = signal(menuList);
}
